import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/maintenance_dob/maintenanceSchedulesReportActions'
import * as api from '../../../api/reports/maintenance_dob/maintenanceSchedulesReport'

function* maintenanceSchedulesReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.MAINTENANCE_SCHEDULES_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.MAINTENANCE_SCHEDULES_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* maintenanceSchedulesReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.MAINTENANCE_SCHEDULES_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.MAINTENANCE_SCHEDULES_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */

function* watchmaintenanceSchedulesReportGetJobList() {
  yield takeLatest(
    constants.MAINTENANCE_SCHEDULES_REPORT_GET_JOB_LIST.ACTION,
    maintenanceSchedulesReportGetJobList
  )
}

function* watchmaintenanceSchedulesReportGetFullReport() {
  yield takeLatest(
    constants.MAINTENANCE_SCHEDULES_REPORT_GET_FULL_REPORT.ACTION,
    maintenanceSchedulesReportGetFullReport
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchmaintenanceSchedulesReportGetJobList),
    fork(watchmaintenanceSchedulesReportGetFullReport)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/maintenance_dob/maintenanceSchedulesReportSaga.js